
function openModal(id, overlay) {
    const modal = document.querySelector(`.modal-${id}`);
    return function () {
        overlay.classList.remove('hidden');
        modal.classList.remove('hidden');
    }
}
function closeModals(overlay) {
    const modals = document.querySelectorAll('#modals .modal');
    return function () {
        overlay.classList.add('hidden');
        for (let i = 0; i < modals.length; i++) {
            if (!modals[i].classList.contains('hidden')) {
                modals[i].classList.add('hidden');
            }
        }
    }
}

export default function bindModals() {
    const overlay = document.querySelector('.overlay');
    // attach open modal events
    let slides = document.querySelectorAll('.glide__slide');
    for (let s = 0; s < slides.length; s++) {
        const id = parseInt(slides[s].getAttribute('data-id'));
        slides[s].querySelector('img').addEventListener('click', openModal(id, overlay));
        slides[s].querySelector('.label').addEventListener('click', openModal(id, overlay));
    }
    // attach close modal events
    overlay.addEventListener('click', closeModals(overlay));
    let closeBtns = document.querySelectorAll('#modals .close');
    for (let i = 0; i < closeBtns.length; i++) {
        closeBtns[i].addEventListener('click', closeModals(overlay));
    }
}